import { cssTransition } from 'react-toastify';

// This custom transition is just to be able to set different durations on the existing Slide transition
export const FastSlide = cssTransition({
	enter: 'Toastify__slide-enter',
	exit: 'Toastify__slide-exit',
	duration: [450, 50],
	appendPosition: true,
});
